module.exports = "<div class=\"container\">\n  <h1>Painel Principal</h1>\n  <button  md-raised-button (click)=\"login()\">Login</button>\n  <button  md-raised-button (click)=\"logout()\">Logout</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = 402
// module chunks = 0